export default "__VITE_ASSET__572e73de__"